<h2 class="comp-title">Datepicker</h2>
<mat-form-field>
    <input matInput [matDatepicker]="picker" [formControl]="date" placeholder="בחר תאריך">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>



